import { configReducer } from '../../store/config/config.reducer';
import { TemplateRegistration } from '../templateRegistration';
import { AppState } from '../../store/initialStateRegistration';
import {
    GET_PAGE_DATA,
    GET_PALETTE_DATA,
    INJECT_ACCESSIBILITY_ICON_TO_HEADER,
    INJECT_ADS,
    INJECT_BUTTON_TO_FOOTER_LINKS_SECTION,
    INJECT_BUTTON_TO_MENU,
    INJECT_VIDEO_LOGO,
} from '../../client/clientAPI/events';
import { announcementReducer } from '../../store/announcement/announcement.reducer';
import { footerReducer } from '../../store/navigations/ampNavigation/footer-old/footer.reducer';
import { headerReducer } from '../../store/navigations/navigation/header/header.reducer';
import { menuReducer } from '../../store/navigations/navigation/menu/menu.reducer';
import { getAnalyticsCoreParamsForAllPages } from '../utils/getAnalyticsCoreParams';
import { SearchPageKampalaComponent } from './SearchPageKampalaComponent';
import { searchPageReducer } from '../../store/template/searchPage/searchPage.reducer';

export const rootReducer = {
    config: configReducer,
    footer: footerReducer,
    header: headerReducer,
    menu: menuReducer,
    template: searchPageReducer,
    siteAnnouncement: announcementReducer,
};

const getCoreParams = (state: AppState) => ({
    ...getAnalyticsCoreParamsForAllPages(state),
});

export const SearchPageKampala = new TemplateRegistration()
    .setComponent(SearchPageKampalaComponent)
    .setRootReducer(rootReducer)
    .setCoreParams(getCoreParams)
    .addClientAPIEvent(INJECT_VIDEO_LOGO)
    .addClientAPIEvent(GET_PAGE_DATA)
    .addClientAPIEvent(INJECT_BUTTON_TO_FOOTER_LINKS_SECTION)
    .addClientAPIEvent(INJECT_BUTTON_TO_MENU)
    .addClientAPIEvent(GET_PALETTE_DATA)
    .addClientAPIEvent(INJECT_ADS)
    .addClientAPIEvent(INJECT_ACCESSIBILITY_ICON_TO_HEADER)
    .build();
